/*
  Photo review carousel (snippets/photo-review-carousel.liquid)

  Progressive: without JavaScript the track is a native horizontal scroller
  with snap points, which already swipes on a phone. The script adds the
  arrows and dots, and only when there are more cards than fit (three cards
  on a desktop row need neither). It never auto-rotates.

  One dot per scroll POSITION, not per card: with three cards in view and
  thirteen cards, there are eleven places the track can rest, and a dot for
  a position that can never be reached would be a dead control.

  No review content is built here: every card is server-rendered Liquid.
  Was assets/testimonials-showcase.js (Trello 380) until the carousel moved
  into a shared snippet on 2026-10-08 (Trello #459).
*/
(function () {
  'use strict';

  function push(event, props) {
    var p = props || {};
    p.event = event;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(p);
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-trc-track]');
    var nav = root.querySelector('[data-trc-nav]');
    var prev = root.querySelector('[data-trc-prev]');
    var next = root.querySelector('[data-trc-next]');
    var dotsWrap = root.querySelector('[data-trc-dots]');
    if (!track || !nav || !prev || !next || !dotsWrap) return;
    var cards = Array.prototype.slice.call(track.children);
    var positions = 0;
    var current = -1;

    function cardStep() {
      if (cards.length < 2) return track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function visibleCount() {
      return Math.max(1, Math.round((track.clientWidth + 1) / cardStep()));
    }

    function indexNow() {
      var max = track.scrollWidth - track.clientWidth;
      // At the far end the last position may sit less than one step from the
      // previous one, so snap the final index rather than rounding into it.
      if (track.scrollLeft >= max - 2) return positions - 1;
      return Math.min(positions - 1, Math.round(track.scrollLeft / cardStep()));
    }

    function go(i) {
      var target = Math.max(0, Math.min(positions - 1, i));
      track.scrollTo({ left: target * cardStep() });
    }

    function buildDots() {
      dotsWrap.textContent = '';
      for (var i = 0; i < positions; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'trc-dot';
        dot.setAttribute('aria-label', 'Show review ' + (i + 1));
        dot.addEventListener('click', go.bind(null, i));
        dotsWrap.appendChild(dot);
      }
    }

    function sync() {
      var i = indexNow();
      prev.disabled = i <= 0;
      next.disabled = i >= positions - 1;
      Array.prototype.forEach.call(dotsWrap.children, function (dot, n) {
        if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      if (i !== current && current !== -1) {
        push('testimonials_carousel_moved', { index: i });
      }
      current = i;
    }

    function layout() {
      // Hidden (display: none): every width is 0 and the index would come out
      // as -Infinity, so skip until a resize lays it out visible.
      if (!track.clientWidth) return;
      var count = cards.length - visibleCount() + 1;
      if (count !== positions) {
        positions = count;
        buildDots();
      }
      nav.hidden = positions < 2;
      sync();
    }

    prev.addEventListener('click', function () { go(indexNow() - 1); });
    next.addEventListener('click', function () { go(indexNow() + 1); });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    window.addEventListener('resize', layout);
    layout();
  }

  // Report each review once, when it is actually seen, so the dataLayer says
  // which carousel cards reached the viewport.
  function initReviewViews(root) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        push('testimonials_review_viewed', { ref: entry.target.getAttribute('data-ref') || '' });
        io.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    root.querySelectorAll('[data-trc-review]').forEach(function (n) { io.observe(n); });
  }

  function boot() {
    document.querySelectorAll('[data-trc-carousel]:not([data-trc-ready])').forEach(function (root) {
      root.setAttribute('data-trc-ready', '1');
      initCarousel(root);
      initReviewViews(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', boot);
})();
